import BenefitsContent from '../components/Communications/Contents/Benefits';
import PrestationWithCode from '../components/Communications/Contents/PrestationWithCode';

// type Communication
// id: number,
// title: string,
// children: Component,
// paths: string[] | null,
// acceptCircle: boolean,
// variable?: string,
// activeFromDate?: string, // format DD-MM-YYYY
// activeToDate?: string, // format DD-MM-YYYY
// customButtons?: boolean,

export const communications = [
  {
    id: 1,
    title: 'AVISO',
    children: <BenefitsContent />,
    paths: ['/tramites-conectividad', '/tramites-de-autorizaciones'],
    variable: 'advice-benefits',
    acceptCircle: false,
    activeFromDate: '',
    activeToDate: '08-04-2024', // DD-MM-YYYY
    customButtons: false,
  },
  {
    id: 2,
    title: '¡Mejorar la experiencia es un trabajo en equipo!',
    children: <PrestationWithCode />,
    paths: ['/tramites-de-autorizaciones'],
    variable: 'prestation-code',
    acceptCircle: false,
    activeFromDate: '01-06-2024', // DD-MM-YYYY
    activeToDate: '31-12-2024', // DD-MM-YYYY
    customButtons: true,
  },
];
